<app-data-table title="Rate Unit Mappings"
                [columns]="columns"
                [fetchDataFn]="loadData"
                [exportDataFn]="exportData"
                [reloadEmitter]="reloadTable$"
                [enableGlobalSearch]="true"
                [loading]="loading"
                [globalFilterFields]="['rate_unit', 'rate_unit_mapped']"
                globalSearchPlaceholder="Search by rate unit"
                defaultSortField="rate_unit"
                [exportable]="authService.hasPermission('rate_unit_mappings.rate_unit_mappings.export')">
</app-data-table>
